import Pricing4 from './Pricing4'
export default Pricing4
